/**
 * Syncs Telegram Mini App user language to localStorage before app bootstrap.
 * Must be imported first in main.ts so that app.config reads the correct initial lang.
 */
const SUPPORTED_LANGS = ['ru', 'gb', 'es', 'pt', 'de', 'tr', 'ar', 'zh', 'kr', 'ja', 'id'] as const;
const STORAGE_KEY = 'bk_lang';

function mapTelegramLanguageCode(code: string): string {
  const n = code.toLowerCase();
  if (n.startsWith('ru')) return 'ru';
  if (n.startsWith('de')) return 'de';
  if (n.startsWith('es')) return 'es';
  if (n.startsWith('pt')) return 'pt';
  if (n.startsWith('tr')) return 'tr';
  if (n.startsWith('ar')) return 'ar';
  if (n.startsWith('zh')) return 'zh';
  if (n.startsWith('ko') || n.startsWith('kr')) return 'kr';
  if (n.startsWith('ja') || n.startsWith('jp')) return 'ja';
  if (n.startsWith('id') || n.startsWith('in')) return 'id';
  if (n.startsWith('en') || n.startsWith('gb')) return 'gb';
  return 'ru';
}

function syncTelegramLangToStorage(): void {
  try {
    const w = typeof window !== 'undefined' ? (window as Window & { Telegram?: { WebApp?: { initDataUnsafe?: { user?: { language_code?: string } } } } }) : null;
    if (!w?.Telegram?.WebApp?.initDataUnsafe?.user) return;

    const alreadySelected = w.localStorage.getItem(STORAGE_KEY);
    if (alreadySelected) return;

    const code = w.Telegram.WebApp.initDataUnsafe.user.language_code;
    if (!code || typeof code !== 'string') return;

    const lang = mapTelegramLanguageCode(code);
    if (SUPPORTED_LANGS.includes(lang as (typeof SUPPORTED_LANGS)[number])) {
      w.localStorage.setItem(STORAGE_KEY, lang);
    }
  } catch {
    // ignore
  }
}

syncTelegramLangToStorage();
